import React from "react";

const closeIcon = (
	<svg
		width="48"
		height="48"
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="48" height="48" rx="4" fill="#7A7A7A" fillOpacity="0.4" />
		<rect
			x="18.3428"
			y="16.9287"
			width="18"
			height="2"
			rx="1"
			transform="rotate(45 18.3428 16.9287)"
			fill="white"
		/>
		<rect
			x="31.0713"
			y="18.3438"
			width="18"
			height="2"
			rx="1"
			transform="rotate(135 31.0713 18.3438)"
			fill="white"
		/>
	</svg>
);

export default closeIcon;
